import React from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";
// WIZARD
import { WizardProvider } from "../../setupWizard/WizardContext";
import StepChannels from "../../setupWizard/steps/StepChannels";

function ChannelsEdit() {
  const leave = useLeaveStandaloneEditor("/edge-management/channels");
  const location = useLocation();
  const idChannel = new URLSearchParams(location.search).get("idChannel");

  return (
    <WizardProvider>
      <StepChannels
        editChannelId={idChannel || undefined}
        standalone
        onSaveSuccess={leave}
        onCancel={leave}
      />
    </WizardProvider>
  );
}

export default ChannelsEdit;
